import React, { useState } from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemText} from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ConfirmDialog from 'app/shared/widgets/ConfirmDialog';
import TrashIconButton from 'app/shared/widgets/TrashIconButton';

// itemLabel nombra qué se está borrando dentro del diálogo ("el destinatario").
const ConfirmableItemList = ({item, itemLabel = 'el elemento', onTrash=() => {}}) => {
    const [showConfirm, setShowConfirm] = useState(false)

    return (
        <React.Fragment>
            <ListItem
                secondaryAction={
                    <TrashIconButton edge="end" size="medium" onClick={() => setShowConfirm(true) } />
                }>
                <ListItemAvatar>
                    <Avatar>
                        <AccountCircleOutlinedIcon/>
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={item} />
            </ListItem>

            <ConfirmDialog
                open={showConfirm}
                title="Eliminar"
                message={<>¿Estás seguro que deseas eliminar {itemLabel} <strong>{item}</strong>?</>}
                onClose={() => setShowConfirm(false)}
                onConfirm={() => { setShowConfirm(false); onTrash(); }}
            />
        </React.Fragment>
    )

};

export default ConfirmableItemList;
